import Input from '@components/inputs/input/input.component'
import Select from '@components/inputs/select/select.component'
import BatmanService from '@services/batman/batman.service'
import LogService from '@services/log/log.service'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

export default ({
  label = '',
  disabled = false,
  readOnly = false,
  errorSpan = true,
  required = false,
  externalError = '',
  errorIcon = <i className="fa-regular fa-exclamation-triangle"></i>,

  id = '',
  name = '',
  leftLabel = '',
  rightLabel = '',
  externalIcon = null,
  value = '',
  placeholder = '',
  backgroundColor = '',
  className = '',
  onChange = null,
  onValidate = null,
  requiredOnLoad = false,
  country = 'BR',
}) => {
  const { t } = useTranslation()
  const batmanService = useMemo(() => new BatmanService(), [])
  const logService = useMemo(() => new LogService(), [])
  logService.init('Input States')
  const [loading, setLoading] = useState(true)
  const [state, setState] = useState({
    value: value,
    error: '',
  })
  const [statesList, setStatesList] = useState<
    Array<{
      value: string
      text: string
    }>
  >([])

  const handleChange = async (event) => {
    state.value = event
    if (externalError) {
      state.error = ''
    } else if (!!required && (!state.value || state.value.length < 1)) {
      state.error = t('required')
    } else {
      state.error = ''
    }

    setState({ ...state })
    if (onValidate && typeof onValidate === 'function') {
      onValidate(!state.error && !externalError)
    }
    if (onChange && typeof onChange === 'function') {
      onChange(state.value)
    }
  }

  useEffect(() => {
    try {
      batmanService.getStates().then((states) => {
        setStatesList(states)
        setLoading(false)
      })
    } catch (error) {
      logService.error({ message: 'Fail to get Brasilian states', error })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (state.value !== value) {
      handleChange(value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, country, state])

  if (country === 'BR') {
    return (
      <Select
        label={label}
        disabled={disabled}
        readOnly={readOnly}
        errorSpan={errorSpan}
        required={required}
        externalError={externalError || state?.error}
        errorIcon={errorIcon}
        id={id}
        loading={loading}
        name={name}
        leftLabel={leftLabel}
        rightLabel={rightLabel}
        requiredOnLoad={requiredOnLoad}
        externalIcon={externalIcon}
        value={state?.value}
        placeholder={placeholder || t('placeholderState')}
        backgroundColor={backgroundColor}
        className={className}
        onChange={handleChange}
      >
        {statesList?.map((s) => {
          return (
            <option value={s.value} key={s.value}>
              {s.text}
            </option>
          )
        })}
      </Select>
    )
  }

  return (
    <Input
      label={label}
      disabled={disabled}
      readOnly={readOnly}
      errorSpan={errorSpan}
      required={required}
      externalError={externalError || state?.error}
      errorIcon={errorIcon}
      id={id}
      name={name}
      leftLabel={leftLabel}
      rightLabel={rightLabel}
      requiredOnLoad={requiredOnLoad}
      externalIcon={externalIcon}
      value={state?.value}
      placeholder={placeholder || t('placeholderState')}
      backgroundColor={backgroundColor}
      className={className}
      onChange={handleChange}
    />
  )
}
